import {createRouter, createWebHistory} from "vue-router";
import DashboardRoute from "@/router/dashboard";
import LoginRegistrationRoute from "@/router/login-registration";
import TournamentRoute from "@/router/tournament";
import TopicRoute from "@/router/topic";
import CategoryRoute from "@/router/category";
import NotFoundRoute from "@/router/not-found";
import GamePlay from "@/router/game-play";
import PaymentMethod from "@/router/payment-method";

const default_routes = [];

default_routes.push(
    ...LoginRegistrationRoute,
    ...DashboardRoute,
    ...TournamentRoute,
    ...TopicRoute,
    ...CategoryRoute,
    ... GamePlay,
    ... PaymentMethod,
    ...NotFoundRoute
);

let routes = default_routes;

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    linkActiveClass: "active",
});

router.beforeEach((to, from, next) => {
    const auth = JSON.parse(window.localStorage.getItem('auth'));

    if (to.name && (to.name.name === 'Login') && auth && auth.token) {
        return next('/dashboard');
    }

    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (auth && auth.token) {
            return next()
        }
        return next('/login')
    }
    next();
})

export default router;
